export const FETCH_USER_ROLES_REQUEST = '@userRoles/FETCH_USER_ROLES_REQUEST';
export const FETCH_USER_ROLES_SUCCESS = '@userRoles/FETCH_USER_ROLES_SUCCESS';
export const FETCH_USER_ROLES_FAILURE = '@userRoles/FETCH_USER_ROLES_FAILURE';
